import React, { FC, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { INotification, NotificationType } from '../../../utils/hooks/useNotificator/useNotificator.types';
import { GenericNotification } from './GenericNotification';
import { EVENT_ADOBE_EXPRESS_EDIT_RETRY, useAppEvents } from '../../../services/appEvents';
import { useAdobeExpressBI } from '../../../utils/hooks/useAdobeExpress/useAdobeExpressBI';

export const editInAdobeFailedToOpenNotification =
  (): FC<{ notification: INotification }> =>
  ({ notification }) => {
    const { trackAdobeOpenError } = useAdobeExpressBI();
    const { appEvents } = useAppEvents();

    useEffect(() => {
      trackAdobeOpenError();
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
      <GenericNotification
        notification={notification}
        text={<FormattedMessage id="error.open-adobe.general" />}
        type={NotificationType.Destructive}
        buttonProps={{
          label: <FormattedMessage id="error.open-adobe.general.CTA" />,
          onClick: () => appEvents.emit(EVENT_ADOBE_EXPRESS_EDIT_RETRY),
        }}
      />
    );
  };

enum AdobeErrorCode {
  NoInternet = 'NO_INTERNET',
}

interface AdobeError extends Error {
  code?: string;
}

export const editInAdobeFailedNotification =
  (error?: AdobeError): FC<{ notification: INotification }> =>
  ({ notification }) => {
    const { trackAdobeSavingError } = useAdobeExpressBI();

    useEffect(() => {
      trackAdobeSavingError();
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
      <GenericNotification
        notification={notification}
        text={
          <FormattedMessage
            id={error?.code === AdobeErrorCode.NoInternet ? 'error.save-adobe.no_internet' : 'error.save-adobe.general'}
          />
        }
        type={NotificationType.Destructive}
      />
    );
  };
